import Link from "next/link";
import { cn } from "@/lib/utils/cn";
import { MenuSectionLinkProps } from "@/lib/types/nav";

export default function MenuSectionLink({
  item,
  handleClose,
  index,
  lastIndex,
  className,
}: MenuSectionLinkProps) {
  const isLastItem = index === lastIndex;

  return (
    <li>
      <Link
        href={item.href}
        onClick={handleClose}
        className={cn(
          "block border-b py-4",
          className,
          isLastItem && "mb-6",
        )}
      >
        {item.label}
      </Link>
    </li>
  );
}
